var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// stylesheets
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
// components
import PurchaseBody from "./PurchaseBody";
import Footer from "./PurchaseFooter";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
// helpers
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
// types
import { TransactionTypeEnum } from "@domains/features/Markets/AIF-PMS/entities/GlobalEntity";
import { changeInRupeeFormat } from "../../utils";
import { EHoldingType } from "@domains/features/Markets/AIF-PMS/entities/PurchaseEntity";
import actions from "@mainDi/features/AIF-PMS/actions";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
function PurchaseJourney(_a) {
    //
    var _this = this;
    var _b;
    var visible = _a.visible, setVisible = _a.setVisible, onClickCancel = _a.onClickCancel, onClickContinue = _a.onClickContinue, paymentLoading = _a.loading, onSelectClient = _a.onSelectClient, subCategoryId = _a.subCategoryId, errorMessage = _a.errorMessage, errorVisible = _a.errorVisible;
    var _c = __read(useState(true), 2), leadId = _c[0], setLeadId = _c[1];
    var _d = __read(useState(false), 2), loading = _d[0], setLoading = _d[1];
    var _e = __read(useState(false), 2), rmSelection = _e[0], setRmSelection = _e[1];
    var _f = __read(useState(false), 2), leadNotExists = _f[0], setLeadNotExits = _f[1];
    var searchParams = new URLSearchParams(location.search);
    var cActions = actions();
    var _g = __read(useState(false), 2), isCxoButtonEnabled = _g[0], setIsCxoButtonEnabled = _g[1];
    var _h = useSelector(function (state) { return state.markets.AifPms; }), watchListData = _h.watchListData, transactionId = _h.transactionId, clientDetails = _h.clientDetails, draftOrderDetails = _h.draftOrderDetails, productDetails = _h.productDetails;
    var profileData = useSelector(function (state) {
        return state.Profile.ProfileDetails.reducersData.data.profileDetails;
    });
    useEffect(function () {
        var _a;
        if (transactionId > 0) {
            if (draftOrderDetails && ((_a = Object.keys(draftOrderDetails)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                getDraftOrderDetails();
                setLeadId(false);
            }
        }
    }, [draftOrderDetails]);
    useEffect(function () {
        if ((clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.ispansearch) === "true") {
            setLeadId(profileData === null || profileData === void 0 ? void 0 : profileData.isCxo);
        }
    }, [clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.ispansearch, profileData === null || profileData === void 0 ? void 0 : profileData.isCxo]);
    useEffect(function () {
        //  if (
        //   searchParams.get("leadid") !== "" &&
        //   searchParams.get("leadid") !== null &&
        //   searchParams.get("leadid") !== undefined &&
        //   Object.values(productDetails).every((e) => e == null)
        // ) {
        //   cActions.global.selectLeadId(null);
        //   setLeadId(true);
        // } else
        if (searchParams.get("leadid") !== "" &&
            searchParams.get("leadid") !== null &&
            searchParams.get("leadid") !== undefined) {
            cActions.global.selectLeadId(searchParams.get("leadid"));
            setLeadId(false);
        }
    }, []);
    var getDraftOrderDetails = function () { return __awaiter(_this, void 0, void 0, function () {
        var data, trx_amt, form_number, setup_fee_percent, passout_percent, payment_mode, bank_name, bank_code, cheque_number, cheque_date, client_name, ac_code, pan, ucccode, trx_type_code, trx_type, rtgs_number, passout_user_code, passout_user_name, passout_user_type, clienttier, paymentType, updatedPaymentModeValues;
        var _a;
        return __generator(this, function (_b) {
            try {
                data = draftOrderDetails.data;
                trx_amt = data.trx_amt, form_number = data.form_number, setup_fee_percent = data.setup_fee_percent, passout_percent = data.passout_percent, payment_mode = data.payment_mode, bank_name = data.bank_name, bank_code = data.bank_code, cheque_number = data.cheque_number, cheque_date = data.cheque_date, client_name = data.client_name, ac_code = data.ac_code, pan = data.pan, ucccode = data.ucccode, trx_type_code = data.trx_type_code, trx_type = data.trx_type, rtgs_number = data.rtgs_number, passout_user_code = data.passout_user_code, passout_user_name = data.passout_user_name, passout_user_type = data.passout_user_type, clienttier = data.clienttier;
                aifPmsDi.payment.updatePurchaseData({
                    amount: String(changeInRupeeFormat(String(trx_amt))),
                    formNo: form_number !== null && form_number !== void 0 ? form_number : "",
                });
                aifPmsDi.payment.updatePurchaseFeeValueProp({
                    setUpFees: String(setup_fee_percent ? setup_fee_percent : 0),
                    sbName: {
                        display_code: passout_user_code !== null && passout_user_code !== void 0 ? passout_user_code : "",
                        display_name: passout_user_name !== null && passout_user_name !== void 0 ? passout_user_name : "",
                        display_type: passout_user_type !== null && passout_user_type !== void 0 ? passout_user_type : "",
                    },
                    passout: String(passout_percent ? passout_percent : 0),
                });
                paymentType = payment_mode === EHoldingType.RTGS || payment_mode == ""
                    ? EHoldingType.RTGS
                    : EHoldingType.Cheque;
                updatedPaymentModeValues = {
                    type: paymentType,
                    bankName: {
                        label: bank_name || "",
                        value: bank_code || "",
                    },
                    chequeNo: cheque_number !== 0 && cheque_number !== null
                        ? String(cheque_number)
                        : "",
                    chequeDate: cheque_date ? new Date(cheque_date) : null,
                    rtgsNo: rtgs_number,
                };
                aifPmsDi.payment.updatePaymentModeValues(updatedPaymentModeValues);
                aifPmsDi.aifPms.updateClientDetails(__assign(__assign({}, clientDetails), { clientName: client_name, accountCode: ucccode, pan: pan, ucccode: ucccode, uniqueCode: ucccode, clienttier: clienttier }));
                aifPmsDi.global.activeTrxTypeList({
                    trx_type_code: trx_type_code,
                    trx_type: trx_type,
                });
                if (trx_type == TransactionTypeEnum.TopUp) {
                    aifPmsDi.payment.updateTopupValues({
                        amount: String(changeInRupeeFormat(String(trx_amt))),
                        folio: (_a = data === null || data === void 0 ? void 0 : data.folio_number) !== null && _a !== void 0 ? _a : "",
                    });
                }
                setLoading(false);
            }
            catch (error) {
                setLoading(false);
            }
            return [2 /*return*/];
        });
    }); };
    var onSideBarClose = function () {
        onClickCancel();
        aifPmsDi.aifPms.ordersData(null);
        cActions.global.toggleLeadSelection(false);
        cActions.leadservice.searchLead(null);
        cActions.global.selectLeadId(null);
        cActions.leadservice.selectLoginSearchData(null);
        cActions.draft.draftOrderDetails(null);
        cActions.purchase.updateValidateForm({
            requestid: "",
            success: false,
            message: "",
            statuscode: "",
            errors: "",
            data: {
                is_formNoExist: false,
                message: "",
                is_edit: false,
                trxid: null,
                trxtype: "",
            },
        });
        if (typeof searchParams !== "undefined") {
            var url = window.location.pathname;
            window.history.replaceState(null, "", url);
        }
    };
    return (React.createElement(GenericSidebar, { parentClassname: "primary-aif-pms-sidebar-container d-flex flex-column", header: React.createElement("div", { className: "read-more-tooltip align-items-center aif-pms-genericScheme aif-pms-genericScheme-d" },
            React.createElement(GenericSchemeName, { name: (_b = ((watchListData === null || watchListData === void 0 ? void 0 : watchListData.display_name) || (watchListData === null || watchListData === void 0 ? void 0 : watchListData.scheme_name))) !== null && _b !== void 0 ? _b : "", subText2: Number(ESubProductIds === null || ESubProductIds === void 0 ? void 0 : ESubProductIds.AIF) === subCategoryId
                    ? watchListData === null || watchListData === void 0 ? void 0 : watchListData.isin_code
                    : undefined, subText1: subCategoryId == Number(ESubProductIds.AIF)
                    ? watchListData === null || watchListData === void 0 ? void 0 : watchListData.category
                    : watchListData === null || watchListData === void 0 ? void 0 : watchListData.amc_product_name, maxWidth: 305, showTooltip: true, showImage: true, wrap: true })), body: React.createElement(PurchaseBody, { subCategoryId: subCategoryId, loading: loading || paymentLoading, onSelectClient: onSelectClient, leadId: leadId, setLeadId: setLeadId, rmSelection: rmSelection, leadNotExists: false, setLeadNotExits: setLeadNotExits, errorMessage: errorMessage, errorVisible: errorVisible, setIsCxoButtonEnabled: setIsCxoButtonEnabled, isCxoButtonEnabled: isCxoButtonEnabled }), footer: React.createElement(Footer, { onClickCancel: onClickCancel, onClickContinue: onClickContinue, leadId: leadId, setLeadId: setLeadId, setRmSelection: setRmSelection, rmSelection: rmSelection, leadNotExists: false, setLeadNotExits: setLeadNotExits, setIsCxoButtonEnabled: setIsCxoButtonEnabled, isCxoButtonEnabled: isCxoButtonEnabled }), openKey: visible, setOpenKey: setVisible, arrowClose: true, delay: 10, blurBackground: true, onSideBarClose: onSideBarClose, parentIcon: "edel-icon-close" }));
}
export default PurchaseJourney;
